import PickDatasetsDatasets from '@/assets/datasets/pick_dataset.json'
import PushDataDatasets from '@/assets/datasets/push_data.json'
import SetRelevanceDatasets from '@/assets/datasets/set_relevance.json'

export const ignoreStateReset = [
  'userId',
  'applicationId',
  'searchApiKey',
  'writeApiKey'
]

export function getInitialState() {
  return {
    guestAppId: 'B1G2GM9NG0',
    guestAPIKey: 'aadef574be1f9252bb48d4ea09b5cfe5',
    userId: undefined,
    applicationId: undefined,
    writeApiKey: undefined,
    searchApiKey: undefined,
    steps: [
      {
        label: 'Pick Dataset',
        completed: false,
        visited: false
      },
      {
        label: 'Push Data',
        completed: false,
        visited: false
      },
      {
        label: 'Set Relevance',
        completed: false,
        visited: false
      },
      {
        label: 'Build UI',
        completed: false,
        visited: false
      },
      {
        label: 'Success',
        completed: false,
        visited: false
      }
    ],
    datasets: {
      pickDataset: PickDatasetsDatasets,
      pushData: PushDataDatasets,
      setRelevance: SetRelevanceDatasets
    },
    uiLibraries: [
      {
        id: 'instantsearchjs',
        slug: 'js',
        label: 'JavaScript',
        name: 'InstantSearch.js',
        codeSandboxModulePath: '/src/app.js',
        forceRefresh: 1
      },
      {
        id: 'react',
        slug: 'react',
        label: 'React',
        name: 'React InstantSearch',
        codeSandboxModulePath: '/src/App.tsx',
        forceRefresh: 0
      },
      {
        id: 'vue',
        slug: 'vue',
        label: 'Vue',
        name: 'Vue InstantSearch',
        codeSandboxModulePath: '/src/App.vue',
        forceRefresh: 0
      },
      {
        id: 'angular',
        slug: 'angular',
        label: 'Angular',
        name: 'Angular InstantSearch',
        codeSandboxModulePath: '/src/app/app.component.html',
        forceRefresh: 0
      }
    ],
    dataset: 0,
    indexingLanguage: 0,
    uiLibrary: 0,
    openCodeSandbox: false,
    uploadedRecordsAmount: 0
  }
}
